<template>
  <div class="nav-bar">
    <div class="type-selection">
      <div class="type-selection__body">
        <div v-for="nav in navs" :key="nav.id" class="check-item" :class="{ active: currentNav === nav.value }" @click="$emit('setNav', nav.value)">
          <span class="check-item__content">
            <span class="check-item__txt">{{ nav.name }}</span>
          </span>
        </div>
      </div>
    </div>

    <button @click="getLink" class="link-button">
      {{ $t("platform.settings.more_about_format") }}
      <svg width="12" height="12" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.7 0C7.39624 0 7.15 0.246243 7.15 0.55C7.15 0.853757 7.39624 1.1 7.7 1.1H9.12218L4.28609 5.93609C4.0713 6.15088 4.0713 6.49912 4.28609 6.71391C4.50088 6.9287 4.84912 6.9287 5.06391 6.71391L9.9 1.87782V3.3C9.9 3.60376 10.1462 3.85 10.45 3.85C10.7538 3.85 11 3.60376 11 3.3V0.55C11 0.246243 10.7538 0 10.45 0H7.7ZM1.1 1.65C1.1 1.34624 1.34624 1.1 1.65 1.1H4.4C4.70376 1.1 4.95 0.853757 4.95 0.55C4.95 0.246243 4.70376 0 4.4 0H1.65C0.73873 0 0 0.73873 0 1.65V9.35C0 10.2613 0.73873 11 1.65 11H9.35C10.2613 11 11 10.2613 11 9.35V6.56333C11 6.25958 10.7538 6.01333 10.45 6.01333C10.1462 6.01333 9.9 6.25958 9.9 6.56333V9.35C9.9 9.65376 9.65376 9.9 9.35 9.9H1.65C1.34624 9.9 1.1 9.65376 1.1 9.35V1.65Z"
          fill="#317475"
        />
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    currentNav: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      formatMapping: {
        NativeWebPush: "push",
        InPage: "inpage",
        OnClick: "onclick",
      },
      navs: [
        {
          id: 1,
          name: "OnClick",
          value: "OnClick",
        },
        {
          id: 2,
          name: "Native Web Push",
          value: "NativeWebPush",
        },
        {
          id: 3,
          name: "InPage",
          value: "InPage",
        },
      ],
    };
  },
  methods: {
    getLink() {
      const targetFormat = this.formatMapping[this.currentNav];

      this.$router.push({
        name: "FAQ",
        query: { format: targetFormat },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.nav-bar {
  margin-bottom: 40px;

  .link-button {
    position: relative;
    width: 100%;
    border-radius: 10px;

    svg {
      position: absolute;
      top: 14px;
      right: 13px;
    }
  }
}

.type-selection {
  margin: 0 0 20px;
  position: relative;

  .type-selection__body {
    display: flex;
    overflow-x: auto;
    gap: 0 18px;
  }

  .check-item {
    white-space: nowrap;
    margin-bottom: 5px;
    border: solid 1px transparent;
    border-radius: 10px;

    &.active {
      border-color: #38807d;
      background-color: #f5f9f8;
      color: #38807d;
    }
  }
}
</style>
